import { render, staticRenderFns } from "./_Confirmation.vue?vue&type=template&id=005af862"
import script from "./_Confirmation.vue?vue&type=script&lang=js"
export * from "./_Confirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports